module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Henry Holt and Company, LLC"), _c('br'), _c('em', [_vm._v("Publishers since 1866")]), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, New York 10010"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.HenryHoltKids.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HenryHoltKids.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Henry Holt"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Henry Holt and Company, LLC."), _c('br'), _vm._v("Text copyright © 2009 by Marian Hale")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved."), _c('br'), _vm._v("Distributed in Canada by H. B. Fenn and Company Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data Hale, Marian."), _c('br'), _vm._v("The goodbye season / Marian Hale.—1st ed."), _c('br'), _vm._v("p.       cm."), _c('br'), _vm._v("Summary: In Canton, Texas, seventeen-year-old Mercy’s dreams of a different life than her mother’s are postponed by harsh circumstances, including the influenza epidemic of 1918–19, which forces her into doing domestic work for a loving, if troubled, family."), _c('br'), _vm._v("ISBN 978-0-8050-8855-7"), _c('br'), _vm._v("[1. Coming of age—Fiction. 2. Family life—Texas—Fiction. 3. Household"), _c('br'), _vm._v("employees—Fiction. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("4")]), _vm._v(". Mothers and daughters—Fiction. 5. Grief—Fiction."), _c('br'), _vm._v("6. Texas—History—1846–1950—Fiction.] I. Title."), _c('br'), _vm._v("PZ7.H1373Goo 2009 [Fic]—dc22 2008050275")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Edition—2009"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper.∞")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1 3 5 7 9 10 8 6 4 2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0